import React from "react";
import {AutoCompleteAddressFormInput} from "../../utils/AutoCompleteAddress";
import {BriefMainServices, ServiceIdToName} from "../../consts";
import {Spin} from "antd";
import moment from "moment";

export const buildBriefFormFields = (
    providers = [],
    address,
    onAddressChange,
    disable = false,
    disabledFields = [],
    hideFields = [],
    services = BriefMainServices,
    isLoadingProviders = false
) => {
    return [
        {
            name: isLoadingProviders ? undefined : "providerIds",
            label: "למי תרצו לשלוח את הבריף?",
            type: "select",
            optionFilterProp: "children",
            showSearch: true,
            multiple: true,
            disabled: disable || isLoadingProviders || disabledFields.includes("providerIds"),
            optional: true,
            placeholder: isLoadingProviders ? <Spin size="small" /> : "בחירת ספק",
            rowClassName: "provider-select-row",
            formItemClassName: "provider-select",
            popupClassName: "provider-select-popup",
            optionLabelProp: "label",
            subLabel:
                "בחרו ספק אחד או יותר שאליהם תרצו לשלוח את הבריף. ניתן גם להשאיר ריק והצוות שלנו ישלח לספקים המתאימים ביותר בהתאם לבריף.",
            options: providers?.map(({brandName, providerId, imageUrl, productKosherType}) => ({
                label: brandName || "",
                name: providerId,
                tag: productKosherType,
                imageUrl:
                    imageUrl ||
                    "https://res.cloudinary.com/well-b-prod/image/upload/c_fill,f_auto,g_faces,q_80,w_500/quLmpxH8h.png"
            }))
        },
        {
            name: "eventInfoTitle",
            type: "custom",
            disabled: disable || disabledFields.includes("eventInfoTitle"),
            rowClassName: "event-info-container",
            customComponent: <div className="event-info-title">פרטי האירוע</div>
        },
        {
            name: "row1",
            type: "multi",
            disabled: disable || disabledFields.includes("row1"),
            inputs: [
                {
                    label: "כתובת לשילוח הזמנה",
                    name: "address",
                    disabled: disable || disabledFields.includes("address"),
                    required: true,
                    rules: [
                        {
                            required: true,
                            validator: (_, result) => {
                                if (!result && result !== 0) {
                                    return Promise.reject("שדה חובה");
                                }
                                return Promise.resolve();
                            }
                        }
                    ],
                    customComponent: (
                        <AutoCompleteAddressFormInput
                            allowSelectRegularText={false}
                            editValue={address}
                            disabled={disable || disabledFields.includes("address")}
                            locationTypes={[]}
                            placeholder="הזן רחוב/ מס׳ בנין/ עיר"
                            countriesToSearchIn={["IL"]}
                            onChange={(_trimmedAddress, option) => {
                                onAddressChange(_trimmedAddress, {placeId: option?.place_id});
                            }}
                        />
                    ),
                    type: "custom",
                    placeholder: "הזן עיר/ רחוב / מס׳ בניין"
                },
                {
                    label: "קומה",
                    name: "floor",
                    type: "number",
                    disabled: disable || disabledFields.includes("floor"),
                    className: "floor-input",
                    placeholder: "קומה"
                },
                {
                    label: "מספר משתתפים משוערך",
                    type: "number",
                    disabled: disable || disabledFields.includes("participantsAmount"),
                    name: "participantsAmount",
                    placeholder: "יש להזין כמות"
                }
            ]
        },

        {
            name: "whenEventDetails",
            type: "multi",
            disabled: disable || disabledFields.includes("whenEventDetails"),
            inputs: [
                {
                    label: "תאריך אירוע",
                    name: "date",
                    type: "date",
                    disabled: disable || disabledFields.includes("date"),
                    placeholder: "בחר תאריך",
                    disabledDate: current => current && current < moment().add(2, "days").startOf("day"),
                    renderExtraFooter: () => (
                        <p style={{padding: 2, color: "#999", lineHeight: 1.2}}>
                            לא ניתן להכין הצעה בהתראה קצרה במערכת, אם זה דחוף דברו איתנו בווטסאפ ונבנה יחד הצעה מהירה
                        </p>
                    )
                },
                {
                    label: "שעת תחילת האירוע",
                    name: "time",
                    disabled: disable || disabledFields.includes("time"),
                    type: "time",
                    placeholder: "יש להזין שעה"
                }
            ]
        },
        ...(!hideFields.includes("serviceId")
            ? [
                  {
                      name: "serviceId",
                      label: "קטגוריה",
                      type: "select",
                      disabled: disable || disabledFields.includes("serviceId"),
                      required: true,
                      placeholder: "בחר קטגוריה",
                      options: Object.entries(services).map(([serviceId, serviceName]) => ({
                          label: ServiceIdToName[serviceName],
                          name: serviceName,
                          value: serviceName
                      }))
                  }
              ]
            : []),
        {
            name: "row3",
            type: "multi",
            disabled: disable || disabledFields.includes("row3"),
            inputs: [
                {
                    label: "תקציב מקסימלי לאירוע כולל עלות משלוח(כולל מע״מ)",
                    name: "maxPrice",
                    disabled: disable || disabledFields.includes("maxPrice"),
                    type: "number",
                    placeholder: "הזן את סכום התקציב",
                    required: true
                },
                {
                    label: "מס הזמנת רכש",
                    type: "text",
                    disabled: disable || disabledFields.includes("poNumber"),
                    name: "poNumber",
                    optional: true
                }
            ]
        },
        {
            name: "description",
            label: "פרטים נוספים",
            type: "textarea",
            minRows: 5,
            disabled: disable || disabledFields.includes("description"),
            optional: true,
            placeholder: "ספרו לנו כאן את כל הדגשים והפרטים שחשוב לכם שבית העסק ייקח בחשבון בעת בניית הצעת מחיר"
        }
    ];
};
